import { render, staticRenderFns } from "./ConnectedTasks.vue?vue&type=template&id=3d9ea7d8&"
import script from "./ConnectedTasks.vue?vue&type=script&lang=js&"
export * from "./ConnectedTasks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports